import { jsx as i, jsxs as G } from "react/jsx-runtime";
import { useState as g, useRef as p, useCallback as L, useEffect as w } from "react";
import "../node_modules/@manifoldxyz/js-ts-utils/dist/currency-D_lXt-g5.es.js";
import "../node_modules/@manifoldxyz/js-ts-utils/dist/network-BRHI3AkZ.es.js";
import { u as z } from "../node_modules/@manifoldxyz/js-ts-utils/dist/urls-Dz-Ya70q.es.js";
import "../node_modules/@manifoldxyz/js-ts-utils/dist/providerEvents-BNyUv4Ea.es.js";
import "../node_modules/@manifoldxyz/js-ts-utils/dist/errors-Jh6CB33H.es.js";
import I from "./VideoPlayer.es.js";
import $ from "../composables/useIntersectionObserver.es.js";
import { OnLoadOnErrorDefaults as B, classes as u } from "../utils/component.es.js";
import { getMediaTypeForContentType as P, injectGoogleModelViewer as U, convertPotentialSVGOrHEICOrTIFF as D, getMediaTypeForFileExtension as J } from "../utils/web.es.js";
import K from "./PDFViewer.es.js";
const le = ({
  src: l,
  poster: f,
  showImageOnly: h,
  onLoad: M,
  onError: j,
  className: s,
  style: d,
  contentTypeOverride: T
}) => {
  const [n, W] = g(""), [m, F] = g(""), [y, S] = g(""), v = p(null), b = p(null), k = p(null), E = p(!1), R = p(null), { onLoad: q, onError: A } = B, c = L(() => {
    M?.();
  }, [q, M]), e = L(() => {
    j?.();
  }, [A, j]), O = L(
    async (a) => {
      if (!E.current) {
        E.current = !0;
        try {
          let r = z.convertPotentialWeb3ProtocolURLToWeb2URL(a), t = "unknown", o = null;
          if (r.startsWith("blob:") || r.startsWith("data:"))
            r.startsWith("blob:") ? o = (await (await fetch(r)).blob()).type : o = r.split(":")[1].split(";")[0], t = P(o);
          else {
            const x = await fetch(r, { method: "HEAD" });
            if (o = x.headers.get("content-type"), x.status !== 200)
              throw new Error("Unable to HEAD request for content type");
            t = P(o);
          }
          if (T && (t = P(T)), t === "model" && await U(), t === "image" && o)
            try {
              r = await D(r, o, void 0);
            } catch {
              e();
            }
          W(t), F(r);
        } catch {
          let r = z.convertPotentialWeb3ProtocolURLToWeb2URL(a);
          const t = /\.[^/.]+$/.exec(r), o = J(t ? t[0] : "");
          if (o === "model" && await U(), o === "image" && t)
            try {
              r = await D(r, void 0, t[0]);
            } catch {
              e();
            }
          W(o), F(r);
        }
      }
    },
    [e]
    // eslint-disable-line react-hooks/exhaustive-deps
  ), H = L(async () => {
    if (!l) {
      e();
      return;
    }
    if (await O(h && f ? f : l), f && !h) {
      const a = z.convertPotentialWeb3ProtocolURLToWeb2URL(f);
      S(a);
    }
    n === "audio" && b.current && typeof b.current.load == "function" && b.current.load(), n === "unknown" && e();
  }, [l, f, h, n, O, e]), { stopObserving: V, observe: C } = $(
    ".m-lazy-media",
    H
  );
  w(() => {
    E.current = !1;
  }, [l]), w(() => (l || e(), v.current && C(v.current), () => {
    V();
  }), [l, C, V, e]), w(() => {
    if (n === "model" && R.current) {
      const a = R.current;
      return a?.addEventListener("load", c), a?.addEventListener("error", e), () => {
        a?.removeEventListener("load", c), a?.removeEventListener("error", e);
      };
    }
  }, [n, c, e]), w(() => {
    n === "model" && U();
  }, [n]);
  const N = () => {
    switch (n) {
      case "image":
        return /* @__PURE__ */ i(
          "img",
          {
            src: m,
            onLoad: c,
            onError: e,
            className: u("rcl--size-full rcl--object-contain rcl--object-center", s),
            style: d
          }
        );
      case "video":
        return /* @__PURE__ */ i(
          I,
          {
            src: m,
            poster: y || "",
            className: u("rcl--size-full rcl--object-contain rcl--object-center", s),
            style: d,
            onLoad: c,
            onError: e,
            "data-testid": "video-player"
          }
        );
      case "model":
        return /* @__PURE__ */ i(
          "model-viewer",
          {
            ref: R,
            src: m,
            style: d,
            autoplay: !0,
            "auto-rotate": !0,
            "interaction-prompt": "none",
            "seamless-poster": !0,
            "shadow-intensity": "1",
            "camera-controls": !0,
            className: u("rcl--aspect-square rcl--size-full rcl--border-none", s)
          }
        );
      case "audio":
        return /* @__PURE__ */ G(
          "div",
          {
            className: u(
              "rcl--flex rcl--w-full rcl--flex-col rcl--items-center rcl--justify-center rcl--gap-2",
              s
            ),
            style: d,
            children: [
              y && /* @__PURE__ */ i(
                "img",
                {
                  ref: k,
                  src: y,
                  className: "rcl--pointer-events-none rcl--h-[calc(100%-54px-0.5rem)] rcl--object-contain rcl--object-center"
                }
              ),
              /* @__PURE__ */ i(
                "audio",
                {
                  ref: b,
                  controls: !0,
                  onCanPlayThrough: c,
                  onLoadedData: c,
                  onError: e,
                  className: "rcl--h-[54px] rcl--w-full",
                  children: /* @__PURE__ */ i("source", { src: m })
                }
              )
            ]
          }
        );
      case "pdf":
        return /* @__PURE__ */ i(
          K,
          {
            src: m,
            onLoad: c,
            onError: e,
            style: d,
            className: s
          }
        );
      case "html":
        return /* @__PURE__ */ i(
          "iframe",
          {
            src: l,
            title: "Media iframe",
            sandbox: "allow-scripts allow-same-origin",
            allow: "camera *; microphone; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
            onLoad: c,
            onError: e,
            className: u("rcl--aspect-square rcl--size-full rcl--border-none", s),
            style: d
          }
        );
      default:
        return;
    }
  };
  return /* @__PURE__ */ i(
    "div",
    {
      ref: v,
      className: u(
        "m-lazy-media rcl--relative rcl--flex rcl--size-full rcl--max-h-full",
        "rcl--max-w-full rcl--items-center rcl--justify-center",
        "rcl--duration-500",
        n === "audio" ? "rcl--flex rcl--flex-col rcl--items-center rcl--justify-center rcl--gap-2" : ""
      ),
      children: N()
    }
  );
};
export {
  le as default
};
//# sourceMappingURL=LazyMedia.es.js.map
